'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = Contact;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _ajaxRequest = require('ajaxRequest');

var _ajaxRequest2 = _interopRequireDefault(_ajaxRequest);

function Contact() {

	var _contactForm = document.querySelector('#contact-form');
	if (!_contactForm) return;

	var _btSubmit = _contactForm.querySelector('button[type=submit]'),
	    _inputs = _contactForm.querySelectorAll('input[type="text"], textarea'),
	    _confirmField = _contactForm.parentNode.querySelector('.confirm');
	var isLoading = false,
	    to = undefined;

	var submitForm = function submitForm() {
		if (isLoading) return;
		isLoading = true;

		(0, _domClasslist2['default'])(_btSubmit).remove('ok');
		(0, _domClasslist2['default'])(_btSubmit).remove('ko');
		(0, _domClasslist2['default'])(_confirmField).remove('active');

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var input = _step.value;

				(0, _domClasslist2['default'])(input).remove('error');
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		var currentUrl = document.location.href;
		var reqContent = (0, _formSerialize2['default'])(_contactForm) + '&todo=contact';
		//console.log(reqContent);
		TweenMax.to(_btSubmit, .2, { autoAlpha: 0, onComplete: function onComplete() {
				(0, _ajaxRequest2['default'])(currentUrl, reqContent)['catch'](function (error) {
					console.log(error);
				}).then(JSON.parse).then(function (body) {
					//console.log(body)
					isLoading = false;
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = body[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var el = _step2.value;

							if (el.level == 'error') {
								(0, _domClasslist2['default'])(_contactForm.querySelector('#' + el.field)).add('error');
								(0, _domClasslist2['default'])(_btSubmit).add('ko');
								_confirmField.innerHTML = el.msg;
								clearTimeout(to);
								to = setTimeout(function () {
									(0, _domClasslist2['default'])(_btSubmit).remove('ko');
								}, 1500);
							} else {
								(0, _domClasslist2['default'])(_btSubmit).add('ok');
								if (el.field == "btn") _btSubmit.setAttribute("value", el.msg);
								if (el.field == "msg") _confirmField.innerHTML = el.msg;

								TweenLite.to(_contactForm, 0.33, { height: 0 });

								/*for(const input of _inputs){
        	input.disabled = true;
        	input.readOnly = true;
        }*/
							}
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2['return']) {
								_iterator2['return']();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}).then(function () {
					(0, _domClasslist2['default'])(_confirmField).add('active');
					TweenMax.to(_btSubmit, .2, { autoAlpha: 1 });
					(0, _domClasslist2['default'])(_confirmField).add('active');
				});
			} });
	};

	var addHandlers = function addHandlers() {
		_btSubmit.addEventListener('click', clickSubmit);

		var els = document.querySelectorAll('input, textarea');

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = els[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var el = _step3.value;

				el.addEventListener('keyup', function () {
					if (this.value !== '') {
						this.classList.add('not-empty');
					} else {
						this.classList.remove('not-empty');
					}
				});
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3['return']) {
					_iterator3['return']();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	};

	var clickSubmit = function clickSubmit(e) {
		e.preventDefault();
		if ((0, _domClasslist2['default'])(_btSubmit).contains('ok')) return;
		submitForm();
	};

	addHandlers();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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